import UsersAPI from "../network/UsersAPI";
import { FieldPermissions } from "./RolePermissions";

export interface FieldPermissionsState {
  userRoles?: string; // JSON string e.g. "[1]" or "[1,9]" — parsed by canEditField/getFieldReadOnly
  fieldPermissions?: FieldPermissions;
}

/**
 * Fetches userRoles and fieldPermissions from the API and calls setState with the results.
 * Use in componentDidMount of any page that passes permissions to modals.
 *
 * Example:
 *   fetchFieldPermissions((state) => this.setState(state));
 */
export function fetchFieldPermissions(
  setState: (state: Partial<FieldPermissionsState>) => void
): void {
  UsersAPI.getUser()
    .then(response => {
      if (response.success && response.user && response.user.length > 0) {
        setState({ userRoles: response.user[0].UserRoles });
      }
    })
    .catch(err => console.error("Failed to fetch user roles:", err));

  UsersAPI.getFieldPermissions()
    .then(response => {
      if (response.success) {
        setState({ fieldPermissions: response.fieldPermissions });
      }
    })
    .catch(err => console.error("Failed to fetch field permissions:", err));
}
